/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// mobile footer menu
$('.Footer__Title--btn').on('click', function(e){
  e.preventDefault();
  var scrollPosition = $(window).height() + $(window).scrollTop();
  if($(this).hasClass('active')){
    $(this).closest('.Faq__Item').removeClass('show-content');
    $(this).next().slideUp();
  }
  else {
    // close opened tabs
  //   $('.Footer__Title--btn').removeClass('active');
  //   $('.Faq__Item').removeClass('show-content');
  //   $('.Footer__Linklist--menu').slideUp();
    // show content of clicked tab
    $(this).next().slideDown();
    $(this).closest('.Faq__Item').addClass('show-content');
    if($(this).hasClass('footer-no-scroll')) {
      $('html, body').animate({scrollTop: scrollPosition + $(this).height() }, '400');
    }
  }
  $(this).toggleClass('active'); 
});

/* Service page tab functionality */
$(document).ready(function() {
    var tabs = $('.tab');
    tabs.click(tabSwitch)
    function tabSwitch() {
      tabs.each(function() {
          $(this).removeClass('is-active')
      })
      $(this).addClass('is-active');
      // Panel
      $('.is-show').removeClass('is-show');
      $('.show-heading').removeClass('show-heading');
      var arrayTabs = Array.prototype.slice.call(tabs);
      var index = arrayTabs.indexOf(this);
      $('.panel').eq(index).addClass('is-show');
      $('.service-heading').eq(index).addClass('show-heading');
	  
	  	// update page url params
		let tabID = $(this).attr('id')
		urlParams.set('page', tabID);
		history.replaceState(null, null, "?"+urlParams.toString());
    };
});


/* Shopify advice load more functionality */
const gridCells = $('.shopify-advice .Grid__Cell')
const loadMoreBtn = $('.load-more-btn')
let shown = 10
const showBlogs = (toShow = 0) => {
    shown += toShow
    gridCells.each((index, el) => {
        if (index < shown) {
            $(el).addClass('visible')
        } else {
            return false
        }
    })
    if (gridCells.length < shown) {
        loadMoreBtn.addClass('hide')
    }
}
const loadMore = () => {
    showBlogs(10)
}
showBlogs()


// footer popup menu(Portfolio page)
function setPopupAlignment() {
	var headerHeight = 0;
	if($(window).width() < 1140) {
		headerHeight = $(".sidecard-layout").height() + 60;
		$('.article-popup-wrapper .Article__Header').css("height", headerHeight.toString()+"px");
		$('.article-popup-wrapper .Article__Content').css("top", headerHeight.toString()+"px");
	} else {
		$('.article-popup-wrapper .Article__Header').removeAttr('style');
		$('.article-popup-wrapper .Article__Content').removeAttr('style');
	}
}

function fetchBlogData(href) {
	$.ajax({
	    url: href,
	   	type: 'get',
	  	beforeSend: function(){
	    	$("#popup-loader").show();
	    },
	   	success: function(response){
	    	var markup = $(response).find(".article-popup-content");
    		$('.Portfolio_Blog .article-popup').fadeOut("fast", function() {
		  		$('.Portfolio_Blog .article-popup-wrapper').hide();
		  		$(this).html('').html($(markup).html());
		  		$(this).fadeIn("fast", function() {
					$('body').css('overflow', 'hidden');
		    	});
		  		$(".image-layout img").on("load", function() {
		   			setPopupAlignment();
		   			$('.Portfolio_Blog .article-popup-wrapper').addClass("article-overlay").animate({scrollTop:0}, 'slow');
	   				$(".Portfolio_Blog #popup-loader").hide();
		   			$('.Portfolio_Blog .article-popup-wrapper').show();
	   			});
		  	});
	   	},
	   	complete:function(data){
	   		
	   	}
	});
}

$(document).on("click", ".Portfolio_Blog .Popover__Value", function() {
	$(".template-blog .Popover__Value").removeClass("is-selected");
	if(!$(this).hasClass('is-selected')) {
		$(this).addClass('is-selected');
	}
	var link = $(this).attr("data-link");
	$(".template-blog .btn_apply").attr("href", link);
});

$(document).on("click", ".Portfolio_Blog .article-popup-trigger, .Portfolio_Blog .popup-navigation", function() {
	var href = $(this).attr('data-link');
	fetchBlogData(href);
});

$(document).on("click", ".Portfolio_Blog .close-button", function() {
	$('.Portfolio_Blog .article-popup').fadeOut("fast", function() {
		$(this).html('');
		$('body').removeAttr('style');
		$('.Portfolio_Blog .article-popup-wrapper').removeClass("article-overlay");
	});
});

$('.Portfolio_Blog .article-popup-wrapper').scroll(function(){
    var $sticky = $('.mobile-sticky'),
    scroll = $('.Portfolio_Blog .article-popup-wrapper').scrollTop();
  
  	if($(window).width() < 1140){
	  	if (scroll > 20) {
		  	$sticky.addClass('fixed');
		} else {
	  		$sticky.removeClass('fixed');
	  	}
	}
});

$(window).on('resize load', function() {
	setPopupAlignment();
});


$(document).ready(function() {

	// EN x CH
	if (window.location.href.indexOf("zh-tw") > -1) {
    $('.text-EN').css({ display: 'none' })
    $('.text-CH').css({ display: 'block' })
  } else {
  	$('.text-EN').css({ display: 'block' })
    $('.text-CH').css({ display: 'none' })
  }	
	
	// Timeline (mobile) i.e. sync display of description
	const targetNode = document.querySelector('.Timeline__ListItem')
	const callback = function(mutationsList, observer) {
		const timelineIndex = targetNode.querySelector('.is-selected').getAttribute('data-index')
		document.querySelectorAll('.Timeline__Item--custom').forEach(item => item.classList.remove('is-selected'))
		document.querySelector(".Timeline__Item--custom[data-index='"+timelineIndex+"']").classList.add('is-selected')
	}
	const observer = new MutationObserver(callback)
	observer.observe(targetNode, {attributes: true, childList: true, characterData: false, subtree:true})

});

// Shopify partners section
$('.slider-content-container').flickity({
	prevNextButtons: true,
	pageDots: false,
	initialIndex: 2,
	arrowShape: { 
		x0: 10,
		x1: 60, y1: 50,
		x2: 65, y2: 40,
		x3: 25
	}
});
// Shopify we-chat footer popup
var liWechat = $(".Linklist__Item.wechat a.Link.Link--primary");

if(liWechat.length > 0){
	$(document).on("click", ".Linklist__Item.wechat a.Link.Link--primary", function(event) {
		event.preventDefault();
		$('.modal-wechat .modal-wechat-content a').attr('href', liWechat.attr('href'));
		$('.modal-wechat .modal-wechat-content a img').attr('src', liWechat.attr('href'));
		document.querySelector('.modal-wechat .modal-wechat-content .wechat_name').innerText = $.trim(liWechat[0].innerText);
		$("body").css("overflowY", "hidden");
		var heightScroll = $(window).height() - 50 + 'px';
		$('.modal-wechat').css('max-height', heightScroll);
		$('.PageOverlay').addClass("overlay_custom");
		$('.modal-wechat').addClass('show');
	});
	$('.modal-wechat').click(function(event) {
		if (!$(event.target).is('.modal-wechat-content'))
		{
			$("body").css("overflowY", "unset");
			$('.PageOverlay').removeClass("overlay_custom");
			$('.modal-wechat').css('max-height', 0);
			$('.modal-wechat').removeClass('show');
		}
	});	
}